<template>
<sidebar-widget
    :start-expanded="startExpanded"
    :sections="sections"
    :headers="['Employee Contribution', 'Employer Match']"
>
    <template v-slot:title>Match Tiers</template>

    <template v-slot:row-details="props">
        <div>
            <span>Employee Contribution: </span> <span>${{ props.row.employee_contribution }}%</span><br />
            <span>Employer Match: </span> <span>${{ props.row.employer_match }}%</span><br />
        </div>
    </template>
</sidebar-widget>

</template>

<script>
import SidebarWidget from './SidebarWidget'

export default {
    props: ['plan', 'startExpanded', ],
    components: {SidebarWidget, },
    computed: {
        sections() {
            const rows = []

            this.plan.match_tiers.forEach(mt => {
                rows.push({
                    employee_contribution: mt.employee_contribution,
                    employer_match: mt.employer_match,
                    cells: [
                        `${mt.employee_contribution}% `,
                        `${mt.employer_match}%`,
                    ],
                    id: Math.random(),
                })
            })

            return [{title: 'Main', rows: rows}]
        },
    },
}
</script>
